<style scoped lang="scss">

</style>

<template>
    <div>
        <div class="uk-form" v-if="application">

            <fieldset data-uk-margin>
                <legend>Third Party to contact servicer or property management company</legend>

                <p v-if="vendor_list.length > 1">
                    The Applicant and any co-applicants and residents 18 years and older (if any) named below (individually and collectively, "Borrower Applicant"), authorize:
                        <ul>
                            <li v-for="vendor_obj in vendor_list"><strong>{{ vendor_obj.name }}</strong> [{{ vendor_obj.type }} provider]</li>
                        </ul>
                        ;and and the Third Parties assisting the {{env.AGENCY_SHORT_NAME}} in the review of the {{application.program.program_abbreviation}} applications (Individually and collectively, "Third Party") to share, release, discuss, and otherwise provide to and with each other public and non-public personal information contained in or related to the lease, utilities, and/or the {{application.program.program_abbreviation}} application of the Applicant.
                </p>
                <p v-else>
                    The Applicant and any co-applicants and residents 18 years and older (if any) named below (individually and collectively, "Borrower Applicant"), authorize all 3rd-party vendors present on this application; and and the Third Parties assisting the {{env.AGENCY_SHORT_NAME}} in the review of the {{application.program.program_abbreviation}} applications (Individually and collectively, "Third Party") to share, release, discuss, and otherwise provide to and with each other public and non-public personal information contained in or related to the lease, utilities, and/or the {{application.program.program_abbreviation}} application of the Applicant.
                </p>

            </fieldset>

            <div class="uk-margin-large-bottom">
                <fieldset>
                    <div class="uk-container uk-margin-top" >
                        <div class="uk-grid" v-if="application.household">
                            <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                                <div v-if="member.age >= 18">
                                    <validated-section :errors="errors" :field="'signature_'+member.id">
                                        <signature-box @updated="onSignatureUpdated"
                                                       :user-key="member.id"
                                                       :is-signed="signatureData[member.id] && signatureData[member.id].third_party_authorization_signed_at !== null"
                                                       :completed="signatureData[member.id] && signatureData[member.id].completed"
                                                       :name="member.first_name + ' ' + member.last_name"
                                                       :color="programSettings['primary-program-color']"
                                        ></signature-box>
                                    </validated-section>

                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";

    export default {
        name: "Step7",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                signatureData: {},
                errors: {},
            }
        },
        computed: {
            ...mapState('Application', {
                assets: state => state.assets,
                application: state => state.application,
                signatures: state => state.signatures,
                vendor_list: state => state.vendorList,
            }),
            ...mapState('App', {
                env: state => state.env,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-privacy-policy`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, { third_party_authorization_signed_at: signatureFiltered.created_at, completed: true });
                        }
                    }
                });
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData[$event.key], 'third_party_authorization_signed_at', $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            async validateStep() {
                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].third_party_authorization_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            
            async save() {
                let data = {
                    signatures: this.signatureData,
                }
                let r = axios.put(`/api/hope/applications/${this.application.id}/step-7`, data);
                await this.$store.dispatch('Application/fetch', this.application.id);
            }
        }
    }
</script>
